import { Component, EventEmitter, Input, Output } from '@angular/core';
import { eColumnType } from '@hub/generated/enums';
import { SubGridItem } from '@hub/models/common/ui/SubGridItem';
import { SortEvent } from 'primeng/api';
import { Constants } from '@hub/common/Constants';
@Component({
  selector: 'app-simple-grid',
  templateUrl: './simpleGrid.component.html'
})
export class SimpleGridComponent {
  private _data: any[] = [];
  // Input Properties
  @Input() Title: string;
  @Input() set Data(d: any[]){
    this._data = d;
    if (Array.isArray(d)) {
      this.totalCount = d.length;
      if (d.length >5) {
        this.ShowPaginator = true;
        this.setFooter({first: this.first, rows: this.rows});
      }
    }
  }
  get Data () {
    return this._data;
  }
  @Input() Columns: SubGridItem[];
  @Input() Selection: any[] = [];
  @Input() IsReadOnly: boolean = false;
  @Input() EmptyMessage: boolean = true;
  @Input() IsResizable: boolean = true;
  @Input() SortField: string;
  @Input() SortOrder: number = 1;
  @Input() ShowPaginator: boolean = false;
  @Input() set RowsPerPage(r: number) {
    this.rows = r;
  }
  
  // Output Properties
  @Output() selectionChange = new EventEmitter();
  @Output() rowDoubleClick = new EventEmitter();
  @Output() faIconClick = new EventEmitter();
  @Output() rowSingleClick = new EventEmitter();
  @Output() onPage = new EventEmitter();

  // Enumerations
  type = eColumnType;
  footerText: string = '';
  totalCount: number;
  first = 0;
  rows = 5;
  rowsPerPageOptions = Constants.ROWS_PER_PAGE_OPTIONS_SUB_GRIDS;

  setFooter(event) {
    // event.first: Index of first record in page
    // event.rows: Number of rows on the page
    this.onPage.emit(event)
    
    if (this.Data.length > 0) {
      let page = (event.first / event.rows);
      const start = page * event.rows + 1;
      let end = start + event.rows - 1;

      if (end > this.Data.length) {
        end = this.Data.length;
      }

      this.footerText = `${start} - ${end} of ${this.Data.length} items`;
    } else {
      this.footerText = '';
    }
  }

  // Public Methods
  // Selection
  public rowSelect(event) {
    this.selectionChange.emit(this.Selection);
  }

  public rowUnselect(event) {
    this.selectionChange.emit(this.Selection);
  }

  public toggleSelection(event) {
    this.selectionChange.emit(this.Selection);
  }

  public onRowDblClick(event, rowData) {
    this.rowDoubleClick.emit(rowData);
  }

  public iconClickHandler(event){
    this.faIconClick.emit(event);
  }

  public onRowSingleClick(rowData){
    this.rowSingleClick.emit(rowData);
  }

  customSort(event: SortEvent) {
    //event.data = Data to sort
    //event.mode = 'single' or 'multiple' sort mode
    //event.field = Sort field in single sort
    //event.order = Sort order in single sort
    //event.multiSortMeta = SortMeta array in multiple sort

    let columnType = this.Columns.find(x => x.Field === event.field).ColumnType;

    event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = null;

        if (value1 == null && value2 != null)
            result = -1;
        else if (value1 != null && value2 == null)
            result = 1;
        else if (value1 == null && value2 == null)
            result = 0;
        else if (typeof value1 === 'string' && typeof value2 === 'string')
            result = value1.localeCompare(value2);
        else if (columnType === eColumnType.Hyperlink)
            result = value1.Value.localeCompare(value2.Value);
        else
            result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

        return (event.order * result);
    });
  }
}
